import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export function setAuthToken(token) {
  if (token) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem("fb_token", token);
  } else {
    delete http.defaults.headers.common.Authorization;
    localStorage.removeItem("fb_token");
  }
}

const existing = localStorage.getItem("fb_token");
if (existing) http.defaults.headers.common.Authorization = `Bearer ${existing}`;
